import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import { yekanFa } from "@config/fonts";
import { CacheProvider } from "@layouts/cache-provider";
import { ThemeProvider } from "@layouts/theme-provider";
import { NextPage } from "next";
import { AppProps } from "next/app";
import Head from "next/head";
import { ReactElement } from "react";
export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactElement;
};
type AppPropertiesWithLayout = AppProps & {
  Component: NextPageWithLayout;
};
function MyApp({
  Component,
  pageProps
}: AppPropertiesWithLayout) {
  const getLayout = Component.getLayout ?? (page => page);
  return <div className={yekanFa.className} data-sentry-component="MyApp" data-sentry-source-file="_app.tsx">
      <Head data-sentry-element="Head" data-sentry-source-file="_app.tsx">
        <title>{process.env.NEXT_PUBLIC_APP_TITLE}</title>
        <meta name="application-name" content={process.env.NEXT_PUBLIC_APP_TITLE} data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="apple-mobile-web-app-capable" content="yes" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="apple-mobile-web-app-title" content={process.env.NEXT_PUBLIC_APP_TITLE} data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="msapplication-tap-highlight" content="no" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="description" content={process.env.NEXT_PUBLIC_APP_TITLE} data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="format-detection" content="telephone=no" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="mobile-web-app-capable" content="yes" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="msapplication-config" content="/browserconfig.xml" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/icons/icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/icons/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="167x167" href="/icons/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/icons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/icons/favicon-16x16.png" />
        <link rel="manifest" href="/manifest.json" />
        <link rel="mask-icon" href="/icons/safari-pinned-tab.svg" color="#ffc40d" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <meta name="msapplication-TileColor" content="#ffc40d" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="theme-color" content="#ffffff" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width,shrink-to-fit=no,user-scalable=no, viewport-fit=cover" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
      </Head>

      <ThemeProvider data-sentry-element="ThemeProvider" data-sentry-source-file="_app.tsx">
        <CacheProvider data-sentry-element="CacheProvider" data-sentry-source-file="_app.tsx">{getLayout(<Component {...pageProps} />)}</CacheProvider>
      </ThemeProvider>
    </div>;
}
export default MyApp;